<template lang="pug">
article(v-if="!isLoading")
  section.branded
    LogoHeader
      slot(name='header' slot='header')
    Errors(:errors='errors')
    slot(name='main' :calculatedRoute="calculatedRoute")
</template>

<script>
import LogoHeader from "Components/LogoHeader/LogoHeader";
import "./scss";
import Errors from "@/components/Errors.vue";

export default {
  name: "Common",
  components: {
    Errors,
    LogoHeader,
  },
  props: {
    errors: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    replaceTitle: {
      type: Boolean,
    },
    calculatedRoute: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      systemError: false,
      titleStart: this.$app.currentTenant ? this.$app.currentTenant.branding.names.display + " timesheet portal - " : "Initialising...",
    };
  },
  watch: {
    title: {
      handler(newTitle) {
        if (newTitle) {
          document.title = this.replaceTitle ? newTitle : this.titleStart + newTitle;
        }
      },
      immediate: true,
    },
  },
};
</script>
